import React from 'react';
import { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import {
  ITopicPickerProps,
  TopicPicker,
} from '@work4all/components/lib/components/entity-picker/topic-picker/TopicPicker';

import { reactRefSetter } from '@work4all/utils';

import { LabeledInput } from '../../containers/mask-overlays/locked-inputs';

interface Props extends Omit<ITopicPickerProps<false>, 'multiple'> {
  error?: string;
}

export const TopicPickerField = React.forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const { t } = useTranslation();
    const topicWrapperRef = useRef();
    const { error, ...pickerProps } = props;
    const { value, onChange } = pickerProps;

    return (
      <div ref={reactRefSetter(topicWrapperRef, ref)}>
        <EntityPickerPopover
          anchorEl={topicWrapperRef}
          picker={<TopicPicker {...pickerProps} multiple={false} />}
        >
          <LabeledInput
            onClear={() => {
              onChange(null);
            }}
            label={t('COMMON.CATEGORY')}
            error={error}
            value={value?.name || ''}
          />
        </EntityPickerPopover>
      </div>
    );
  }
);
